<template>
  <BasicModal
    :title="'ユーザーのエクスポート'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="set-container">
      <b-message type="is-info" has-icon>
        ユーザー情報をエクスポートします。<br>
        エクスポート実行後、ファイルは自動的にダウンロードされます。
      </b-message>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="exportUser()">エクスポート</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    exportUser () {
      this.$emit('exportUser')
    }
  }
}
</script>

<style lang="scss" scoped>
.set-container {
  padding: 24px;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Setting/organisms/ModalExportUser.vue